import * as React from "react";

type UseSyncStateProps<T> = readonly [() => T, (newValue: T) => void];

/**
 *
 * @param initialValue
 * @returns [accessor, setState]
 * Use this if you want to access the updated state value in the same render cycle
 */
export default function useSyncState<T>(initialValue: T): UseSyncStateProps<T> {
  const ref = React.useRef<T>(initialValue);
  const [, forceUpdate] = React.useState(0);

  return [
    React.useCallback(() => ref.current, []),
    React.useCallback((newValue: T) => {
      ref.current = newValue;
      // re-render
      forceUpdate((x) => x + 1);
    }, []),
  ] as const;
}
